module.exports = __webpack_public_path__ + "media/images/Cindy_Cooper-97ec05a0a68ff5e7fd8d9bd7ecf86dbe.jpg";